import React from 'react';
import { Link } from 'react-router-dom';
import cn from 'classnames';
import useAuth from '../../../hooks/useAuth';
import { useUserLogoutMutation } from '../../../redux/slices/authSlice';

// Components
import Notifications from './Notifications';

import styles from './Header.module.postcss';

function HeaderNavControls({ cityName, vehicleType }) {
  const { auth, dashboardLink } = useAuth();
  // Every city runs the same vendors landing page now; Portland used to be
  // sent straight to /vendor/register when it was still the legacy site.
  const addTruckLink = '/vendors';

  const [userLogout] = useUserLogoutMutation();

  // Mobile profile icon: links to login when logged out, dashboard/admin when logged in
  const mobileProfileHref = auth.loggedIn ? (auth.admin ? '/admin' : dashboardLink) : '/login';

  return (
    <>
      {/* Mobile-only profile icon */}
      <Link
        to={mobileProfileHref}
        className={cn(styles.Header_mobileOnly, styles.Header_ProfileIcon)}
        aria-label={auth.loggedIn ? 'Dashboard' : 'Log in'}
      >
        <img src='/static/images/icons/profile.svg' alt='' width='20' height='20' />
      </Link>

      { !auth.loggedIn &&
        <>
          <Link to='/login' className={cn(styles.Header_noMobile, styles.Header_Login, 'Button Button--outlined Button--small')}>
            Log in
          </Link>
          <Link to='/catering/requests/new' className={cn(styles.Header_noMobile, styles.Header_PillCta, 'Button Button--small')}>
            Get catering quotes
          </Link>
        </>
      }

      { auth.loggedIn && auth.admin &&
        <Link to='/admin' className={cn(styles.Header_noMobile, 'Button Button--outlined Button--small')}>
          Admin
        </Link>
      }

      { auth.loggedIn && !auth.admin &&
        <Link to={dashboardLink} className={cn(styles.Header_noMobile, 'Button Button--outlined Button--small')}>
          Dashboard
        </Link>
      }

      { auth.loggedIn &&
        <button
          type='button'
          onClick={userLogout}
          className={cn(styles.Header_noMobile, 'Button Button--outlined Button--small')}
        >
          Log out
        </button>
      }

      { auth.loggedIn &&
        <Notifications
          admin={auth.admin}
        />
      }
    </>
  );
}

export default HeaderNavControls;
